<template lang="jade">
  .screen_group.unselectable(v-bind:id="'screen'+id")
    .screen.clearfix.no_pad(v-bind:class="{'editable':editable, 'inProfile': inProfile}" v-el:screen)
      .link_mask(v-if='showLink' v-link=" 'layout' ")
      .mask(v-if='!editable')
      #input1.left-top.resizable.no_pad(
        data-index='1'
        data-bgColor='1'
        v-bind:data-source="mapping['1']"
        v-bind:class="{'focus': windowFocus === '1', 'border': (label.osd['1'].border === 1 || label.osd['1'].border === 2) && !inProfile, 'border_ani': label.osd['1'].border === 2 && !inProfile}"
        v-on:click="toFocus('1')")
        span.label_group(v-if="label.osd['1'].enabled")
          span.window_name(v-if="label.windows['1'].enabled") {{label.windows['1'].text}}
          span.input_name(v-if="label.inputs['1'].enabled") ({{label.inputs[mapping['1']].text}})
          span.custom_name(v-if="label.custom['1'].enabled") &nbsp;{{label.custom['1'].text}}
      #input2.right-top.resizable.no_pad(
        data-index='2'
        data-bgColor='2'
        v-bind:data-source="mapping['2']"
        v-bind:class="{'focus': windowFocus === '2', 'border': (label.osd['2'].border === 1 || label.osd['2'].border === 2) && !inProfile, 'border_ani': label.osd['2'].border === 2 && !inProfile}"
        v-on:click="toFocus('2')")
        span.label_group(v-if="label.osd['2'].enabled")
          span.window_name(v-if="label.windows['2'].enabled") {{label.windows['2'].text}}
          span.input_name(v-if="label.inputs['2'].enabled") ({{label.inputs[mapping['2']].text}})
          span.custom_name(v-if="label.custom['2'].enabled") &nbsp;{{label.custom['2'].text}}
      #input3.left-bottom.resizable.no_pad(
        data-index='3'
        data-bgColor='3'
        v-bind:data-source="mapping['3']"
        v-bind:class="{'focus': windowFocus === '3', 'border': (label.osd['3'].border === 1 || label.osd['3'].border === 2) && !inProfile, 'border_ani': label.osd['3'].border === 2 && !inProfile}"
        v-on:click="toFocus('3')")
        span.label_group(v-if="label.osd['3'].enabled")
          span.window_name(v-if="label.windows['3'].enabled") {{label.windows['3'].text}}
          span.input_name(v-if="label.inputs['3'].enabled") ({{label.inputs[mapping['3']].text}})
          span.custom_name(v-if="label.custom['3'].enabled") &nbsp;{{label.custom['3'].text}}
      #input4.right-bottom.resizable.no_pad(
        data-index='4'
        data-bgColor='4'
        v-bind:data-source="mapping['4']"
        v-bind:class="{'focus': windowFocus === '4', 'border': (label.osd['4'].border === 1 || label.osd['4'].border === 2) && !inProfile, 'border_ani': label.osd['4'].border === 2 && !inProfile}"
        v-on:click="toFocus('4')")
        span.label_group(v-if="label.osd['4'].enabled")
          span.window_name(v-if="label.windows['4'].enabled") {{label.windows['4'].text}}
          span.input_name(v-if="label.inputs['4'].enabled") ({{label.inputs[mapping['4']].text}})
          span.custom_name(v-if="label.custom['4'].enabled") &nbsp;{{label.custom['4'].text}}
    span.ps(v-if='showPs') Output Resolution: {{outResolutionOptions[outResolution]}}
    //- span.ps(v-if='showPs') {{layer}}
</template>
<script>
import { modal } from 'vue-strap'
import interact from 'interact.js'
import $ from 'jquery'
import _ from 'lodash'

export default {
  components: {
    modal
  },
  props: {
    showLink: {
      type: Boolean,
      default: false
    },
    inProfile: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: '1'
    },
    showPs: {
      type: Boolean,
      default: false
    },
    imgs: {
      type: Array,
      default: function () {
        return [
          '',
          require('assets/img/test/output1.jpg'),
          require('assets/img/test/output2.jpg'),
          require('assets/img/test/output3.jpg'),
          require('assets/img/test/output4.jpg')
        ]
      }
    },
    editable: {
      type: Boolean,
      default: true
    },
    splits: {
      type: Object,
      default: function () {
        return {
          '1': {},
          '2': {},
          '3': {},
          '4': {}
        }
      }
    },
    inputs: {
      type: Object
    },
    outResolution: {
      type: String,
      twoway: true
    },
    outRatio: {
      type: Array
    },
    outLayout: {
      type: String,
      twoway: true
    },
    whichSplit: {
      type: String
    },
    windowFocus: {
      type: String,
      twoway: true
    },
    layer: {
      type: Array,
      twoway: true,
      require: true
    },
    outResolutionOptions: {
      type: Object
    },
    label: {
      type: Object,
      default () {
        return {}
      },
      twoway: true
    },
    apply: {
      type: Function,
      default () {
      }
    },
    resizeEvent: {
      type: Object,
      default () {
        return {}
      },
      twoway: true
    },
    mapping: {
      type: Object
    }
  },
  data () {
    return {
      posArray: [],
      bigWidth: 0,
      bigHeight: 0,
      smallWidth: 0,
      smallHeight: 0,
      event: {},
      box: {}
    }
  },
  asyncData () {
  },
  computed: {
  },
  methods: {
    toFocus (key) {
      this.windowFocus = key
    },
    alert (type, title, content) {
      this.$dispatch('alert', {
        type: type,
        title: title,
        content: content
      })
    },
    interact () {
      const vue = this
      let screen = this.$els.screen

      interact('.focus')
      .resizable({
        inertia: false,
        preserveAspectRatio: false,
        // restrict two edges
        edges: {
          left: true,
          right: true,
          bottom: true,
          top: true
        },
        restrict: {
          restriction: screen,
          endOnly: false
        },
        snap: {
          targets: [
            interact.createSnapGrid({ x: 5, y: 5 })
          ],
          range: Infinity,
          relativePoints: [ { x: 0, y: 0 } ]
        },
        enabled: true,
        invert: 'none',
        onmove: function (event) {
          if (event.type === 'resizemove') {
            vue.updateScreenCords(event, 'resize')
            vue.$dispatch('resizemove', event)
          }
        },
        onend: function (event) {
          if (event.type === 'resizeend') {
            vue.$dispatch('resizeend', {
              target: event.target.getAttribute('data-index')
            })
          }
        }
      })
      .draggable({
        // disable inertia throwing
        inertia: false,
        // keep the element within the area of it's parent
        restrict: {
          restriction: screen,
          endOnly: true,
          elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
        },
        snap: {
          targets: [
            interact.createSnapGrid({ x: 5, y: 5 })
          ],
          range: Infinity,
          relativePoints: [ { x: 0, y: 0 } ]
        },
        autoScroll: false,
        onstart: function (event) {
        },
        onmove: function (event) {
          if (event.type === 'dragmove') {
            vue.updateScreenCords(event, 'drag')
          }
        },
        onend: function (event) {
          vue.$dispatch('dragend', {
            target: event.target.getAttribute('data-index')
          })
          console.log(event.target.getAttribute('data-index'))
        }
      }).gesturable({
        restrict: {
          restriction: screen,
          endOnly: true
        },
        maxPerElement: 1,
        onstart: function (event) {
          if (event.type === 'gesturestart') {
            vue.event = event.type
            let target = event.target
            // set the original x, y , width , height of the box
            target.setAttribute('data-bWidth', event.box.width)
            target.setAttribute('data-bHeight', event.box.height)
            target.setAttribute('data-bPreviousX', event.box.x)
            target.setAttribute('data-bPreviousY', event.box.y)
          }
        },
        onmove: function (event) {
          if (event.type === 'gesturemove') {
            vue.event = event.type
            vue.updateScreenCords(event, 'gesture')
          }
        },
        onend: function (event) {
          vue.$dispatch('gestureend', {
            target: event.target.getAttribute('data-index')
          })
          console.log(event.target.getAttribute('data-index'))
        }
      })
    }, // close this.interact
    // Functions that name of it started with _ are used in render screen
    _getSplitSize (screen, screenWidth, screenHeight) {
      // Set screen width and height and posArray
      $(screen).css('width', screenWidth + 'px')
      $(screen).css('height', screenHeight + 'px')

      // get split and let input to specific size
      if (this.outLayout === 'quick') {
        if (this.whichSplit === '2*2') {
          const divisionX = 2
          const divisionY = 2
          this.bigWidth = screenWidth / divisionX
          this.bigHeight = screenHeight / divisionY
          // 2. @Todo: get amount of the enabled inputs and set position
          // ex: 2 * 2 or 3 * 1
          if (this.posArray.length === 0) {
            for (let y = 0; y < divisionY; y++) {
              for (let x = 0; x < divisionX; x++) {
                this.posArray.push({
                  x: x,
                  y: y
                })
              }
            }
          } else {
            let counter = 0
            for (let y = 0; y < divisionY; y++) {
              for (let x = 0; x < divisionX; x++) {
                this.posArray[counter] = {
                  x: x,
                  y: y
                }
                counter++
              }
            }
          }
          // set inputs size
          $('.resizable').width(this.bigWidth)
          $('.resizable').height(this.bigHeight)
        } else {
          this.bigWidth = screenWidth / 3 * 2
          this.bigHeight = screenHeight / 3 * 2
          this.smallWidth = screenWidth / 3
          this.smallHeight = screenHeight / 3 * 1
          $.each($('.resizable'), (i, val) => {
            if (val.getAttribute('data-index') === '1') {
              val.style.width = this.bigWidth + 'px'
              val.style.height = this.bigHeight + 'px'
            } else {
              val.style.width = this.smallWidth + 'px'
              val.style.height = this.smallHeight + 'px'
            }
          })
          switch (this.whichSplit) {
            case 't':
              this.posArray[0] = {
                x: 0.3333 / 2,
                y: 0
              }
              for (let i = 0; i < 3; i++) {
                this.posArray[i + 1] = {
                  x: 0.3333 * i,
                  y: 0.6666
                }
              }
              break

            case 'r':
              this.posArray[0] = {
                x: 0.3333,
                y: 0.3333 / 2
              }
              for (let i = 0; i < 3; i++) {
                this.posArray[i + 1] = {
                  x: 0,
                  y: 0.3333 * i
                }
              }
              break

            case 'b':
              this.posArray[0] = {
                x: 0.3333 / 2,
                y: 0.3333
              }
              for (let i = 0; i < 3; i++) {
                this.posArray[i + 1] = {
                  x: 0.3333 * i,
                  y: 0
                }
              }
              break

            case 'l':
              this.posArray[0] = {
                x: 0,
                y: 0.3333 / 2
              }
              for (let i = 0; i < 3; i++) {
                this.posArray[i + 1] = {
                  x: 0.6666,
                  y: 0.3333 * i
                }
              }
          }
        }
      } else if (this.outLayout === 'full') {
      } else if (this.outLayout === 'custom') {
      } else if (this.outLayout === 'init') {
      }
    },
    _operateCSS (screenWidth, screenHeight) {
      // operate z-index
      let counter = this.layer.length
      for (let i = 0; i < this.layer.length; i++) {
        $('#screen' + this.id + ' .resizable[data-index=' + this.layer[i] + ']').css({
          'z-index': (counter - i).toString()
        })
      }
      const vue = this
      if (this.outLayout === 'quick') {
        let w
        let h
        $.each($('.resizable'), function (i, val) {
          $(val).show() // to avoid hide() from full screen input
          let index = val.getAttribute('data-index')
          vue._updateSplits(index, i, screenWidth, screenHeight)
          if (vue.whichSplit === '2*2') {
            w = vue.bigWidth
            h = vue.bigHeight
          } else {
            w = screenWidth
            h = screenHeight
          }
          val.style.webkitTransform = val.style.transform = 'translate(' + vue.posArray[i].x * w + 'px,' + vue.posArray[i].y * h + 'px)'
          // update the current postion in data-x , data-y
          val.setAttribute('data-x', vue.posArray[i].x * w)
          val.setAttribute('data-y', vue.posArray[i].y * h)
        })
      } else if (this.outLayout === 'full') {
        let focus = this.whichSplit // string
        $.each($('.resizable'), function (i, val) {
          $(val).width(screenWidth).height(screenHeight)
          $(val).css({
            transform: 'translate(0px,0px)'
          })
        })
        // operate this.layer
        let focusIndex = this.layer.indexOf(parseInt(focus))
        let newAry = [this.layer[focusIndex]]
        for (let key = 0; key < this.layer.length; key++) {
          if (this.layer[key] !== this.layer[focusIndex]) newAry.push(this.layer[key])
        }
        this.layer = _.cloneDeep(newAry)

        vue._updateSplits(vue.whichSplit, null, screenWidth, screenHeight)
      } else if (this.outLayout === 'init' || this.outLayout === 'custom') {
        let sizeAry = []
        let toSmall = this.outRatio[3] / this.outRatio[2]
        for (let windowID in this.splits) {
          let size = {
            width: Math.round((this.splits[windowID][2] - this.splits[windowID][0]) * toSmall),
            height: Math.round((this.splits[windowID][3] - this.splits[windowID][1]) * toSmall)
          }
          sizeAry.push(size)
        }
        let query = '#screen' + this.id + ' .resizable'
        $.each($(query), function (i, val) {
          $(val).width(sizeAry[i].width)
          $(val).height(sizeAry[i].height)
          val.style.webkitTransform = val.style.transform = 'translate(' + Math.round(vue.splits[i + 1][0] * toSmall) + 'px,' + Math.round(vue.splits[i + 1][1] * toSmall) + 'px)'
          $(val).attr('data-x', Math.round(vue.splits[i + 1][0] * toSmall))
          $(val).attr('data-y', Math.round(vue.splits[i + 1][1] * toSmall))
        })

        query = '#screen' + this.id + ' .resizable[data-index='
        // operate z-index
        let counter = this.layer.length
        for (let i = 0; i < this.layer.length; i++) {
          $(query + this.layer[i] + ']').css({
            'z-index': (counter - i).toString()
          })
        }
      }
    },
    _updateSplits (index, posIndex, screenWidth, screenHeight) {
      let splits = _.cloneDeep(this.splits)
      const toRealCords = this.outRatio[2] / this.outRatio[3]
      let w
      let h
      if (this.outLayout === 'quick') {
        if (this.whichSplit === '2*2') {
          w = this.bigWidth
          h = this.bigHeight
          splits[index][0] = Math.round((this.posArray[posIndex].x * w * toRealCords))
          splits[index][1] = Math.round((this.posArray[posIndex].y * h * toRealCords))
          splits[index][2] = Math.round((this.posArray[posIndex].x + 1) * w * toRealCords)
          splits[index][3] = Math.round((this.posArray[posIndex].y + 1) * h * toRealCords)
        } else {
          w = screenWidth
          h = screenHeight
          const inputW = index === '1' ? this.bigWidth : this.smallWidth
          const inputH = index === '1' ? this.bigHeight : this.smallHeight

          splits[index][0] = Math.round((this.posArray[posIndex].x * w * toRealCords))
          splits[index][1] = Math.round((this.posArray[posIndex].y * h * toRealCords))
          splits[index][2] = Math.round((this.posArray[posIndex].x * w + inputW) * toRealCords)
          splits[index][3] = Math.round((this.posArray[posIndex].y * h + inputH) * toRealCords)
        }
      } else if (this.outLayout === 'full') {
        // empty the splits
        for (let i in splits) {
          splits[i][0] = splits[i][1] = 0
          splits[i][2] = screenWidth * toRealCords
          splits[i][3] = screenHeight * toRealCords
        }
      }
      // update to vue instance
      this.splits = _.cloneDeep(splits)
    },
    renderScreen () {
      let query = '#screen' + this.id + ' .screen'
      let query2 = '#screen' + this.id + ' .resizable'
      $(query).css({transition: 'all .5s'})
      $.each($(query2), function (i, val) {
        $(val).css({
          transition: 'all .5s ease'
        })
      })
      const screen = this.$els.screen
      const screenWidth = this.outRatio[0] * this.outRatio[3]
      const screenHeight = this.outRatio[1] * this.outRatio[3]

      this._getSplitSize(screen, screenWidth, screenHeight)
      this._operateCSS(screenWidth, screenHeight)
      setTimeout(function () {
        $(query).css({transition: ''})
        $.each($(query2), function (i, val) {
          $(val).css({
            transition: ''
          })
        })
      }, 1000)
      this.interact()
    },
    updateScreenCords (event, type) {
      if (!type) return console.log('need to give it a type')
      const target = event.target
      if (type === 'drag') {
        let x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
        let y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy

        // translate the element
        target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px, ' + y + 'px)'

        // update the posiion attributes
        target.setAttribute('data-x', x)
        target.setAttribute('data-y', y)
        // px => number
        let width = parseInt(target.style.width.replace('px', ''))
        let height = parseInt(target.style.height.replace('px', ''))

        this.updateSplitData(target.getAttribute('data-index'), x, y, width, height)
      } else if (type === 'resize') {
        let limit = 10 // limit percent of resizing

        const screenWidth = this.outRatio[0] * this.outRatio[3]
        const screenHeight = this.outRatio[1] * this.outRatio[3]
        // const limitX = this.outRatio[0] * this.outRatio[2]
        // const limitY = this.outRatio[1] * this.outRatio[2]
        // const toRealCords = this.outRatio[2] / this.outRatio[3]

        let x = (parseFloat(target.getAttribute('data-x')) || 0)
        let y = (parseFloat(target.getAttribute('data-y')) || 0)
        // px to number
        let width = parseInt(target.style.width.replace('px', ''))
        let height = parseInt(target.style.height.replace('px', ''))

        // update the element's style
        if (event.rect.width > screenWidth / limit) {
          target.style.width = event.rect.width + 'px'
          width += event.deltaRect.width
          x += event.deltaRect.left
          target.setAttribute('data-x', x)
        }
        if (event.rect.height > screenHeight / limit) {
          target.style.height = event.rect.height + 'px'
          y += event.deltaRect.top
          height += event.deltaRect.height
          target.setAttribute('data-y', y)
        }

        // translate when resizing from top or left edges

        target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px,' + y + 'px)'

        this.updateSplitData(target.getAttribute('data-index'), x, y, width, height)
      } else if (type === 'gesture') {
        let limit = 10 // limit percent of resizing

        const screenWidth = this.outRatio[0] * this.outRatio[3]
        const screenHeight = this.outRatio[1] * this.outRatio[3]

        // get the original x, y , width , height of the target
        let x = (parseFloat(target.getAttribute('data-x')) || 0)
        let y = (parseFloat(target.getAttribute('data-y')) || 0)
        // px to number
        let width = parseInt(target.style.width.replace('px', ''))
        let height = parseInt(target.style.height.replace('px', ''))

        // // get previous box
        let bPreviousX = parseInt(target.getAttribute('data-bPreviousX'))
        let bPreviousY = parseInt(target.getAttribute('data-bPreviousY'))
        let bWidth = parseInt(target.getAttribute('data-bWidth'))
        let bHeight = parseInt(target.getAttribute('data-bHeight'))

        // update the element's style
        if (width > screenWidth / limit) {
          width += event.box.width - bWidth
          if (width > screenWidth) width = screenWidth
          x += event.box.x - bPreviousX
          if (x < 0) x = 0
          if ((x + width) > screenWidth) x = screenWidth - width
          target.style.width = width + 'px'
          target.setAttribute('data-x', x)
          target.setAttribute('data-bPreviousX', event.box.x)
          target.setAttribute('data-bWidth', event.box.width)
        }
        if (height > screenHeight / limit) {
          height += event.box.height - bHeight
          if (height > screenHeight) height = screenHeight
          y += event.box.y - bPreviousY
          if (y < 0) y = 0
          if ((y + height) > screenHeight) y = screenHeight - height
          target.style.height = height + 'px'
          target.setAttribute('data-y', y)
          target.setAttribute('data-bPreviousY', event.box.y)
          target.setAttribute('data-bHeight', event.box.height)
        }
        // translate when resizing from top or left edges
        target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px,' + y + 'px)'

        this.updateSplitData(target.getAttribute('data-index'), x, y, width, height)
      }
    },
    // To update the splits cords
    updateSplitData (index, x, y, width = null, height = null) {
      let splits = _.cloneDeep(this.splits)
      splits[index][0] = Math.round(x * this.outRatio[2] / this.outRatio[3])
      splits[index][1] = Math.round(y * this.outRatio[2] / this.outRatio[3])

      let limitX = this.outRatio[0] * this.outRatio[2]
      let limitY = this.outRatio[1] * this.outRatio[2]
      // 差距在一定範圍內直接讓他跟原本座標一樣
      if (Math.abs(Math.round((x + width) * this.outRatio[2] / this.outRatio[3]) - limitX) < 5) {
        splits[index][2] = limitX
      } else {
        splits[index][2] = Math.round((x + width) * this.outRatio[2] / this.outRatio[3])
      }

      if (Math.abs(Math.round((y + height) * this.outRatio[2] / this.outRatio[3]) - limitY) < 5) {
        splits[index][3] = limitY
      } else {
        splits[index][3] = Math.round((y + height) * this.outRatio[2] / this.outRatio[3])
      }

      this.splits = _.cloneDeep(splits)
    }
  }, // close methods
  ready () {
  },
  watch: {
    outRatio (nV) {
    }
  },
  events: {
    render (key) {
      console.log('got render in screen', this.id)
      if (key === this.id || key === 'all') {
        this.renderScreen()
      }
    },
    chgResolution () {
      this.outLayout = 'quick'
      this.quickSelectSplit = '2*2'
      this.renderScreen()
    },
    chgZindex (newLayer, key) {
      let query = ''
      if (key && key === this.id || key === 'all') {
        console.log('got chgZindex in Screen.vue' + this.id)
        query = '#screen' + this.id + ' .resizable[data-index='
        // operate z-index
        this.layer = newLayer
        let counter = this.layer.length
        for (let i = 0; i < this.layer.length; i++) {
          $(query + this.layer[i] + ']').css({
            'z-index': (counter - i).toString()
          })
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~__vendor_variables_scss__';
@import '~sass/_breakpoint.scss';
.screen{
  position: relative;
  background-color: $Screen_bg;
  border: 1px solid $Screen_border;
  box-sizing:border-box;
  margin-top: $space_xxs;
  margin-bottom: 0px;
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
  // border: 1px solid #000;
  width: 400px;
  height: 300px;
  & ::selection{
    background-color: transparent;
  }
}
.editable .resizable{

  & .window_pointer{
    display:block;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    width:25px;
    height:25px;
    font-size: 25px;
  }
  & .innerMask{
    background-color: rgba(255,255,255,0.7);
  }
  &.focus{
    font-family: FontAwesome;
    .innerMask{
      background-color: transparent;
    }
    .label_group{
      color: $base_white;
    }
    outline:2px solid #000;
    outline-offset:-2px;
    &:before, &:after{
      content: '';
      display:block;
      width:100%;
      height:10px;
      position: absolute;
      border-left: 10px solid #000;
      border-right:10px solid #000;
      left:0;
    }
    &:before{
      top:0px;
    }
    &:after{
      bottom:0px;
    }
    &[data-bgColor='1']{
      &:before, &:after{
        border-color: darken($window_a, 25%);
      }
      outline: 2px solid darken($window_a, 25%);
      .label_group {
        background-color:darken($window_a, 25%);
      }
    }
    &[data-bgColor='2']{
      &:before, &:after{
        border-color: darken($window_b, 25%);
      }
      outline: 2px solid darken($window_b, 25%);
      .label_group {
        background-color:darken($window_b, 25%);
      }
    }
    &[data-bgColor='3']{
      &:before, &:after{
        border-color: darken($window_c, 25%);
      }
      outline: 2px solid darken($window_c, 25%);
      .label_group {
        background-color:darken($window_c, 25%);
      }
    }
    &[data-bgColor='4']{
      &:before, &:after{
        border-color: darken($window_d, 25%);
      }
      outline: 2px solid darken($window_d, 25%);
      .label_group {
        background-color:darken($window_d, 25%);
      }
    }
  }
}
.resizable{
  &.border{
    outline:2px solid #000;
    outline-offset: -2px;
    &[data-bgColor='1']{
      outline: 2px solid darken($window_a, 25%);
    }
    &[data-bgColor='2']{
      outline: 2px solid darken($window_b, 25%);
    }
    &[data-bgColor='3']{
      outline: 2px solid darken($window_c, 25%);
    }
    &[data-bgColor='4']{
      outline: 2px solid darken($window_d, 25%);
    }
    &.border_ani{
      @keyframes blink {
        50% {
          outline: none;
        }
      }
      animation: blink 1s 0s infinite linear;
    }
  }
  overflow:hidden;
  position: absolute;
  & .label_group{
    position: absolute;
    top: 6%;
    left: 10%;
    display:block;
    width:auto;
    height:20px;
    text-align:center;
    padding: 0 3px;
    white-space:nowrap;
    @include breakpoint(iFive) {
      height:15px;
      font-size: 10px;
    }
  }
  &:nth-of-type(even) {
    & .label_group{
      left:5%;
    }
  }
  .innerMask{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    width:100%;
    height:100%;
  }
  & img{
    width: 100%;
    height: 100%;
  }
  &[data-bgColor='1']{
    background-color: $window_a;
  }
  &[data-bgColor='2']{
    background-color: $window_b;
  }
  &[data-bgColor='3']{
    background-color: $window_c;
  }
  &[data-bgColor='4']{
    background-color: $window_d;
  }

  .showWindowBtn{
    background-color: $base_black;
    color: $base_white;
    position: absolute;
    right: 10px;
    bottom: 10px;
    z-index: 2;
  }
}

.inProfile .label_group{
  font-size: 50%;
}

.mask, .link_mask{
  position: absolute;
  z-index: 40;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  width: 100%;
  height: 100%;
  background-color: transparent;
}
.link_mask{
  z-index:41;
}
.ps{
  width: 100%;
  display:inline-block;
  text-align:center;
}
.forDev{
  position: absolute;
  top: 10px;
  left:10px;
  background-color: #fff;
  z-index: 10000;
}
</style>



// WEBPACK FOOTER //
// Screen.vue?7e4ec40b